<div class={`cms-loading-screen ${$store.loading.show ? 'cms-loading-screen--show' : ''}`}>
  <div class="cms-loading-screen--box">
    <div class="cms-loading-spinner" />

    {#if $store.loading.message}
      <div class="cms-loading-text">
        {$store.loading.message}
      </div>
    {/if}
  </div>
</div>

<script>
  import { getContext } from 'svelte'

  const platform = getContext('platform')
  const { store } = platform
</script>

<style>
  .cms-loading-screen {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    z-index: 9999;
    background: rgba(0,0,0,0.4);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s;
  }

  .cms-loading-screen.cms-loading-screen--show {
    opacity: 1;
    pointer-events: auto;
  }

  .cms-loading-spinner {
    margin: 0 auto;
    border-radius: 100%;
    border: 3px solid #eee;
    border-top: 3px solid #2196f3;
    width: 64px;
    height: 64px;
    animation: cms-loading-spinner 0.8s linear infinite;
  }

  .cms-loading-text {
    margin-top: 8px;
    font-size: 26px;
    text-align: center;
    color: #fff;
  }

  @keyframes cms-loading-spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>